import { render, staticRenderFns } from "./ContactosNuevo.vue?vue&type=template&id=9b93861a"
import script from "./ContactosNuevo.vue?vue&type=script&lang=js"
export * from "./ContactosNuevo.vue?vue&type=script&lang=js"
import style0 from "./ContactosNuevo.vue?vue&type=style&index=0&id=9b93861a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports